module.exports = __webpack_public_path__ + "static/img/bonus_9.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_9.png
// module id = r211
// module chunks = 0